import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { StaticContentPlayHistoryApi } from '../../apis'
import { AppState } from '../../reducers'
import { PlayHistoryService } from './base'

@Injectable()
export class StaticContentPlayHistoryService extends PlayHistoryService{
  constructor(protected api: StaticContentPlayHistoryApi) {
    super(api)
  }
}



// WEBPACK FOOTER //
// ./src/services/play-history/static-content.ts